export type BackExcludedArea = { x: number; y: number; width: number; height: number };

const CONTROLS =
  'input,textarea,select,button,a,[contenteditable="true"],[role="slider"],[role="button"],' +
  '[draggable="true"],[data-native-gesture-block]';

/** Viewport-relative geometry: UIKit can make the start decision without waiting for JS. */
export const iosBackExcludedAreas = (): BackExcludedArea[] => {
  const width = window.innerWidth;
  const height = window.innerHeight;
  if (width <= 0 || height <= 0) return [];
  const areas: BackExcludedArea[] = [];
  for (const node of document.body.querySelectorAll<HTMLElement>('*')) {
    const style = getComputedStyle(node);
    const horizontal =
      node.scrollWidth > node.clientWidth + 1 && /auto|scroll/.test(style.overflowX);
    const dragging = style.touchAction === 'none' || style.touchAction === 'pan-x';
    if (!node.matches(CONTROLS) && !horizontal && !dragging) continue;
    if (node.hidden || style.display === 'none' || style.visibility === 'hidden') continue;
    const rect = node.getBoundingClientRect();
    const x = Math.max(0, rect.left);
    const y = Math.max(0, rect.top);
    const right = Math.min(width, rect.right);
    const bottom = Math.min(height, rect.bottom);
    if (right <= x || bottom <= y) continue;
    areas.push({
      x: x / width,
      y: y / height,
      width: (right - x) / width,
      height: (bottom - y) / height,
    });
  }
  return areas;
};

export const hasIosBackSelection = () => {
  const selection = window.getSelection();
  return !!selection && !selection.isCollapsed;
};
